// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_66e694","title":"_e86c4a","link":"_e8fb83","item":"_b489cf","alternatives":"_4ee3cb"};